import { useSession } from "../../../SessionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { ScreenSequence } from "../Sequences";
import { EndowmentEffectScreen1 } from "./EndowmentEffectScreen1";
import { EndowmentEffectScreen2 } from "./EndowmentEffectScreen2";
import { ResultScreen } from "./ResultScreen";
import { ResultScreenGlobal } from "./ResultScreenGlobal";
import { ExplanationScreen } from "./ExplanationScreen";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { EndowmentEffect } from "../../../../translations/experiments/EndowmentEffect";

export const EndowmentEffectKey = "EndowmentEffect";

/**
 * Hook to get the Endowment Effect experiment sequence with translations
 */
export function useEndowmentEffectSequence(): ScreenSequence {
    const { userData } = useSession();
    const { language } = useLanguage();
    const translations = EndowmentEffect[language] || EndowmentEffect.de;

    // Randomizer: backend sollte hier einen Wert setzen, z.B. "Bedingung 1" / "Bedingung 2"
    const randomizerEndowment = userData?.randomizer1 || "Bedingung 1";

    return {
        name: translations.title,
        description: translations.description,
        group: "A2",
        screens: [
            randomizerEndowment === "Bedingung 2"
                ? { component: EndowmentEffectScreen2 } // Seller
                : { component: EndowmentEffectScreen1 }, // Buyer
            { component: ResultScreen },
            { component: ResultScreenGlobal.component },
            { component: ExplanationScreen },
            {
                component: WellDoneScreen,
                canContinueDefault: false
            }
        ],
        resultScreenIndex: 1,
        explanationScreenIndex: 3
    };
}